module.exports = __webpack_public_path__ + "img/digitalIdentity18.f383d6ed.png";